import { CloseOutlined } from '@ant-design/icons';
import {
  Button,
  Card,
  Select, Space,
} from 'antd';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import Loading from '../../../../components/loading/Loading';
import { theme } from '../../../../utils/themes';
import '../widget.css';
import GraphWidgetsContainer from './graphWidget/GraphWidgetsContainer';
import HistoricalDataWidgetsContainer from './historicDataWidget/HistoricalDataWidgetsContainer';
import HorizontalGraphsContainer from './horizontalGraphWidget/HorizontalGraphsContainer';
import {
  limitedWidgetTypes, superUserWidgets, widgetTypeKeys
} from './utils/widgetTypes';
import MonetaryImpact from './horizontalGraphWidget/monetaryImpactWidget/MonetaryImpact';



const { Option } = Select;

const Widget = ({
  settings, index, setType, removeWidget, canViewValues, isSuperUser,
}) => {
  const [widgets, setWidgets] = useState([]);
  const getAvailableWidgets = () => {
    if (isSuperUser || canViewValues) {
      setWidgets(superUserWidgets);
    } else {
      setWidgets(limitedWidgetTypes);
    }
  };

  useEffect(() => {
    getAvailableWidgets();
  }, [canViewValues, isSuperUser]);

  const content = () => {
    switch (settings.type) {
      case widgetTypeKeys.optimalInventoryByStrategy:
        return (
          <GraphWidgetsContainer
            theme={theme()}
            canViewValues={canViewValues}
            widgetID={widgetTypeKeys.optimalInventoryByStrategy}
            indexBy="id"
            label={superUserWidgets.optimalInventoryByStrategy}
            keysVisible={false}
            keys={['value']}
          />
        );
      case widgetTypeKeys.optimalInventoryByGroup:
        return (
          <GraphWidgetsContainer
            theme={theme()}
            canViewValues={canViewValues}
            widgetID={widgetTypeKeys.optimalInventoryByGroup}
            indexBy="GROUP"
            label={superUserWidgets.optimalInventoryByGroup}
          />
        );
      case widgetTypeKeys.optimalInventoryBySP:
        return (
          <GraphWidgetsContainer
            theme={theme()}
            canViewValues={canViewValues}
            widgetID={widgetTypeKeys.optimalInventoryBySP}
            indexBy="SUPPLY_PROCESS"
            label={superUserWidgets.optimalInventoryBySP}
          />
        );
      case widgetTypeKeys.optimalInventoryByCrit:
        return (
          <GraphWidgetsContainer
            theme={theme()}
            canViewValues={canViewValues}
            widgetID={widgetTypeKeys.optimalInventoryByCrit}
            indexBy="CRITICALITY"
            label={superUserWidgets.optimalInventoryByCrit}
          />
        );
      case widgetTypeKeys.optimalInventoryByROP:
        return (
          <GraphWidgetsContainer
            theme={theme()}
            canViewValues={canViewValues}
            widgetID={widgetTypeKeys.optimalInventoryByROP}
            indexBy="ROP_STATUS"
            label={superUserWidgets.optimalInventoryByROP}
          />
        );
      case widgetTypeKeys.plannedOrders:
        return (
          <HorizontalGraphsContainer
            theme={theme()}
            widgetID={widgetTypeKeys.plannedOrders}
          />
        );
      case widgetTypeKeys.monetaryImpact:
        return <MonetaryImpact theme={theme()} />;
      case widgetTypeKeys.excessStockByStatus:
        return (
          <GraphWidgetsContainer
            theme={theme()}
            canViewValues={canViewValues}
            widgetID={widgetTypeKeys.excessStockByStatus}
            indexBy="GROUP"
            label={superUserWidgets.excessStockByStatus}
            keysVisible={false}
            textWidgetID={widgetTypeKeys.totalExcessStock}
          />
        );
      case widgetTypeKeys.cleanUpWidget:
        return (
          <GraphWidgetsContainer
            theme={theme()}
            canViewValues={canViewValues}
            widgetID={widgetTypeKeys.cleanUpWidget}
            indexBy="GROUP"
            label={superUserWidgets.cleanUpWidget}
          />
        );
      case widgetTypeKeys.inflowWatchlist:
        return (
          <GraphWidgetsContainer
            theme={theme()}
            canViewValues={canViewValues}
            widgetID={widgetTypeKeys.inflowWatchlist}
            indexBy="GROUP"
            label={superUserWidgets.inflowWatchlist}
          />
        );
      case widgetTypeKeys.optimalInvByTime:
        return (
          <HistoricalDataWidgetsContainer
            theme={theme()}
            canViewValues={canViewValues}
            widgetID={widgetTypeKeys.optimalInvByTime}
            label={superUserWidgets.optimalInvByTime}
            textWidgetID={widgetTypeKeys.optInvTot}
          />
        );
      case widgetTypeKeys.inventoryValByTime:
        return (
          <HistoricalDataWidgetsContainer
            theme={theme()}
            canViewValues={canViewValues}
            widgetID={widgetTypeKeys.inventoryValByTime}
            label={superUserWidgets.inventoryValByTime}
            textWidgetID={widgetTypeKeys.inventoryValue}
          />
        );
      default:
        return (
          <Space style={{ width: '100%', justifyContent: 'center' }}>
            <Loading text="Select widget type" spinning={false} />
          </Space>
        );
    }
  };

  return (
    <>
      <Card
        className="dashboard-card"
        index={index}
        type="inner"
        title={(<div />)}
        extra={(
          <div style={{ textAlign: 'right' }}>
            <Select
              bordered={false}
              style={{ width: 270, textAlign: 'right' }}
              placeholder="Widget type"
              value={superUserWidgets[settings.type]}
              onChange={(e) => setType(e, index)}
            >
              {Object.keys(widgets).map((type) => (
                <Option value={type} key={type}>{superUserWidgets[type]}</Option>))}
            </Select>
            <Button
              size="small"
              style={{ textAlign: 'center', marginRight: '10px' }}
              onClick={() => removeWidget(index)}
            >
              <CloseOutlined />
            </Button>
          </div>
        )}
      >
        <div
          draggable
          style={{ cursor: 'default' }}
          onDragStart={(e) => {
            e.preventDefault();
            e.stopPropagation();
          }}
        >
          {content()}
        </div>
      </Card>

    </>
  );
};

export default Widget;

Widget.propTypes = {
  settings: PropTypes.shape({
    type: PropTypes.string,
    width: PropTypes.number,
  }).isRequired,
  index: PropTypes.number.isRequired,
  setType: PropTypes.func.isRequired,
  removeWidget: PropTypes.func.isRequired,
  canViewValues: PropTypes.bool.isRequired,
  isSuperUser: PropTypes.bool.isRequired,
};
